import { computed } from 'vue-demi';
import { RANK } from '../common/enum';
const { useCommonApi } = require('@fegobull/webapi').use;
const request = useCommonApi('quote-rank');

export default (props) => {
    const isCustomRank = computed(() => props.rankType === RANK.CUSTOM);

    const symbolListStr = computed(() => {
        const symbolList = (props.customStocklist || []).map((stock) => stock.symbol || '');
        return symbolList.filter((item) => !!item.trim()).join(',');
    });

    const stockIdStr = computed(() => {
        const stockIdList = (props.customStocklist || []).map((stock) => stock.stockId || '');
        return stockIdList.filter((item) => !!item.trim()).join(',');
    });

    const getCustomRank = async () => {
        const data = {
            stockIds: stockIdStr.value,
            symbols: symbolListStr.value,
            lang: props.language,
            count: props.count
        };
        try {
            return await request.get('get-custom-rank-list', data);
        } catch (err) {
            console.error('custom-rank', err);
        }
    };

    return {
        isCustomRank,
        getCustomRank
    };
};
